import React, { useState, useEffect } from "react";
import { Card, Table } from "react-bootstrap";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import SkeletonTableRow from "../../component/skeletonTableRow/skeletonTableRow";
import { permissionsForDashbaord } from "../../service/api/user/getPermissionsDashboard";
import { assignPermissionToRole } from "../../service/api/user/assignPermissionToRole";
import PrimaryButton from "../../jsx/components/button/primaryButton";

import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import AddRoleModal from "../../jsx/components/addRoleModal/addRoleModal";

const PermissionDashboard = () => {
  const { permissionArr } = useSelector((state) => state.user);
  const permissionArray = permissionArr[0] || [];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [responceMsg, setResponceMsg] = useState("");
  const [toasterType, setToasterType] = useState("");
  const [handleToaster, setHandleToaster] = useState(false);
  const [loading, setLoading] = useState(false);

  const [elements, setElements] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [checkedPermissions, setCheckedPermissions] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [addRoleModal, setAddRoleModal] = useState(false);

  function initLoad() {
    let data = {
      user_id_ids: localStorage.getItem("user_id"),
      page_index: 1,
      page_size: 5,
    };
    dispatch(
      permissionsForDashbaord(data, (res) => {
        savePermissions(res.data.data);
      })
    );
  }

  function savePermissions(permissions) {
    console.log(permissions);
    setPermissions(permissions);
    let updatedCheckedPermissions = [];

    permissions?.map(({ permissions, role_id_ids }) => {
      const roleId = role_id_ids;

      let permissionId = [];
      permissions?.map(({ area, permission_list }) => {
        permission_list?.map(({ hasPermission, permission_id_ids }) => {
          if (hasPermission) {
            permissionId = [...permissionId, permission_id_ids];
          }
        });
      });
      updatedCheckedPermissions = [
        ...updatedCheckedPermissions,
        {
          role_id_ids: roleId,
          role_permission_list: permissionId,
        },
      ];
    });

    setCheckedPermissions(updatedCheckedPermissions);
  }

  const handleCheckboxChange = (id, index, role_id_ids) => {
    setCheckedPermissions((prevCheckedPermissions) => {
      console.log(prevCheckedPermissions);
      const updatedCheckedPermissions = [...prevCheckedPermissions];
      const permissionIds = [
        ...updatedCheckedPermissions[index]?.role_permission_list,
      ];

      const idIndex = permissionIds.indexOf(id);
      if (idIndex !== -1) {
        permissionIds.splice(idIndex, 1);
      } else {
        permissionIds.push(id);
      }

      updatedCheckedPermissions[index] = {
        role_id_ids: role_id_ids,
        role_permission_list: permissionIds,
      };

      return updatedCheckedPermissions;
    });
  };
  useEffect(() => {
    initLoad();
  }, []);

  function assignPermission() {
    setLoading(true);
    let data = {
      role_list: checkedPermissions,
    };
    dispatch(
      assignPermissionToRole(
        data,
        (res) => {
          setLoading(false);
          setResponceMsg(res.data.message);
          setToasterType("success");
          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        },
        (err) => {
          setLoading(false);
          setResponceMsg(err.data.message);
          setToasterType("err");
          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        }
      )
    );
  }

  return (
    <div>
      <Card style={{ background: "white" }}>
        <Card.Body>
          <div className="service-requests-main-container">
            <div className="service-requests-title">
              {" "}
              <span
                onClick={() => {
                  window.history.back();
                }}
                className="back-to-admin-btn">
                <i
                  style={{ marginRight: "10px", cursor: "pointer" }}
                  className="bi bi-arrow-left"></i>
                {"Permission Dashboard"}
              </span>{" "}
            </div>
          </div>

          <div className="d-flex justify-content-end">
            {" "}
            {permissionArray.includes("ASSIGN PERMISSION TO ROLE") && (
              <PrimaryButton
                style={{
                  width: '154px',
                  height: '43px',
                  background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                  border: '2px solid rgba(255, 154, 32, 1)',
                  boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                }}
                className={"mx-2"}
                buttonName={"+ Add Role"}
                onClick={() => {
                  setAddRoleModal(true);
                }}
              />
            )}{" "}
            {permissionArray.includes("ASSIGN PERMISSION TO ROLE") && (
              <PrimaryButton
                style={{
                  width: '120px',
                  height: '43px',
                  background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                  border: '2px solid rgba(255, 154, 32, 1)',
                  boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                }}
                buttonName={"Save"}
                loadingMessage={"Saving"}
                isLoading={loading}
                onClick={assignPermission}
              />
            )}
          </div>

          <Table responsive style={{ zoom: "0.8" }}>
            <thead>
              <th>Permission Area</th>
              {permissions?.map((role) => (
                <th key={role.role_id_ids}>{role.role_name_chr}</th>
              ))}
            </thead>

            <tbody>
              {permissions.length > 0 ? (
                permissions?.[0]?.permissions.map(
                  ({ permission_area_name_chr, permission_list }) => (
                    <React.Fragment key={permission_area_name_chr}>
                      <tr>
                        <td
                          colSpan={permission_list.length + 9}
                          style={{
                            fontWeight: "600",
                            fontSize: "20px",
                            background: "gainsboro",
                          }}>
                          {permission_area_name_chr}
                        </td>
                      </tr>
                      {permission_list.map((permissionRes) => (
                        <tr key={permissionRes.id}>
                          <td>{permissionRes.permission_name_chr}</td>
                          {permissions.map((role, index) => {
                            // console.log(role, 'se role')
                            return (
                              <td>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={
                                    selectAllChecked ||
                                    checkedPermissions[
                                      index
                                    ]?.role_permission_list.includes(
                                      permissionRes.permission_id_ids
                                    )
                                  }
                                  onChange={() =>
                                    handleCheckboxChange(
                                      permissionRes.permission_id_ids,
                                      index,
                                      role.role_id_ids
                                    )
                                  }
                                />
                              </td>
                            );
                          })}
                        </tr>
                      ))}
                    </React.Fragment>
                  )
                )
              ) : (
                <SkeletonTableRow cols={7} />
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      {handleToaster && (
        <ResponceToaster toasterType={toasterType} message={responceMsg} />
      )}
      {addRoleModal && (
        <AddRoleModal
          modalStatus={addRoleModal}
          onClose={() => {
            setAddRoleModal(false);
            initLoad();
          }}
        />
      )}
    </div>
  );
};

export default PermissionDashboard;
